import { tt } from './i18n'

/**
 * What a member of staff's job is called — FRONTEND.md §9.257, FB-417.
 *
 * **The sidebar printed the key.** `AppLayout` rendered `user?.systemRole` under the signed-in name,
 * so the owner read `main_admin` and a cook read `cook`, on every screen of the manager. Legacy names
 * it in its user pill (`components/user-menu.tsx:10`) and always has.
 *
 * **Here rather than in a module**, because the shell cannot import one (§5) and because the mapping
 * already existed **twice** — in the audit-log viewer and in the reports page — while the one place
 * every user looks had neither. A third copy is how the first two would come to disagree.
 *
 * **An unknown role prints as itself.** A role the port has never seen is data, not a bug to hide:
 * showing the key is better than inventing a name for it.
 */
export function roleLabel(role: string | null | undefined): string {
  if (role === 'main_admin') return tt('Hlavný administrátor')
  if (role === 'admin') return tt('Administrátor')
  if (role === 'cook') return tt('Kuchár')
  if (role === 'waiter') return tt('Čašník')
  if (role === 'driver') return tt('Šofér')
  return role ?? '-'
}
